import styled from '@emotion/styled';

const StyledButton = styled.button`
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  max-height: 40px;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
const StyledInput = styled.input`
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  box-shadow: none;
  ::placeholder {
    color: var(--dk-text-dim, #b7bbc2);
  }
  :focus {
    outline: none;
  }
`;

/** 검색결과 — 시안: 플로팅 팝업이 아니라 패널 안 인라인. 검색바 아래에 이어서 표시 */
const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
  padding: 8px;
`;

const ResultCount = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: var(--dk-text, black);
  b {
    color: var(--dk-accent, #0066cc);
    font-weight: 600;
  }
`;

export { InputWrapper, StyledButton, StyledInput, Layout, ResultCount };
